import * as React from "react";
import { useEffect, useState } from "react";
import styled from "@mui/material/styles/styled";
import { IconButton } from "@mui/material";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { QualifiedFeature } from "fe-common/graphql";
import { getQFAndRefinementsLines } from "fe-common/logic";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import ThumbsUp from "../../../assets/thumbsUp.svg";
import ThumbsUpFilled from "../../../assets/thumbsUpFilled.svg";
import ThumbsDown from "../../../assets/thumbsDown.svg";
import ThumbsDownFilled from "../../../assets/thumbsDownFilled.svg";
import { useCreateSharedCase } from "../hooks/useCreateSharedCase";
import { useDiagnosticAgentType } from "../../../context/diagnosticAgent";

//region [[ Styles ]]

const LikeDislikeDiseaseView = styled("div")(({ theme }) => ({}));

const LikeDiseaseButton = styled(IconButton)(
  ({ theme, activated }: { theme?: any; activated: string }) => ({
    color: KahunColorMap.DefaultLight,

    [theme.breakpoints.down(MobileView)]: {
      color: "white",
      padding: "10px",
      filter: activated === "false" ? "brightness(0) invert(1)" : "none",
      backgroundColor: activated === "true" ? "white" : "transparent",

      "&:hover, &:focus": {
        backgroundColor: activated === "true" ? "white" : "transparent",
      },
    },
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LikeDislikeDiseaseProps {
  disease: QualifiedFeature;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LikeDislikeDisease = ({ ...props }: LikeDislikeDiseaseProps) => {
  const [findingTitle] = getQFAndRefinementsLines(props.disease);
  const [agentType] = useDiagnosticAgentType();
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const createSharedCase = useCreateSharedCase(agentType);

  useEffect(() => {}, [liked, disliked]);

  const getCaseId = async () => {
    const patientCaseId = await createSharedCase();
    return patientCaseId;
  };

  const onLike = async () => {
    const caseId = await getCaseId();

    setLiked(!liked);
    setDisliked(false);
    evt({
      category: CATEGORY.MINI_DISEASE,
      action: ACTION.LIKE_DISEASE,
      label: findingTitle + " case id: " + caseId,
    });
  };

  const onDislike = async () => {
    const caseId = await getCaseId();

    setLiked(false);
    setDisliked(!disliked);
    evt({
      category: CATEGORY.MINI_DISEASE,
      action: ACTION.DISLIKE_DISEASE,
      label: findingTitle + " case id: " + caseId,
    });
  };

  return (
    <LikeDislikeDiseaseView>
      <LikeDiseaseButton
        onClick={onLike}
        size={"medium"}
        activated={liked.toString()}
        key={"like" + liked.toString()}
      >
        {liked ? (
          <img src={ThumbsUpFilled} alt={"Thumbs Up"} />
        ) : (
          <img src={ThumbsUp} alt={"Thumbs Up"} />
        )}
      </LikeDiseaseButton>

      <LikeDiseaseButton
        key={"dislike" + disliked.toString()}
        onClick={onDislike}
        size={"medium"}
        activated={disliked.toString()}
      >
        {disliked ? (
          <img src={ThumbsDownFilled} alt={"Thumbs Down"} />
        ) : (
          <img src={ThumbsDown} alt={"Thumbs Down"} />
        )}
      </LikeDiseaseButton>
    </LikeDislikeDiseaseView>
  );
};
